
import { Link } from "react-router-dom";
import { getCurrentUser } from "../../lib/auth_base/localstorage";
import useFetchPage from "../../lib/hooks/use-fetch-page";
import EditForm from "./edit-form";

//

export default function EditContactUs() {
 const user =  getCurrentUser();
  const { data:res,loading } = useFetchPage({ slug: "contact-us", endpoint: "fetch_page" });
  const page = res.status
    ? res.data
    : { title: "Contact Us", description: "Error fetching page" };
  return (
    <>
      <div className="dashboard-page-title">
        <div className="breadcrumbs">
          <Link to="/admin">Dashboard</Link>
          <Link to="/admin/contact-us">Contact Us</Link>
          <span>Edit Contact Us</span>
        </div>
      </div>
      <div className="dashboard-page-content">
        <EditForm
          page={page} 
        />
      </div>
    </>
  );
}
